// store/bbps/pg/pgSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StartPaymentArgs } from "hooks/Bbps/billPayment/useBillPayment";
import type { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";

export type RazorpayStatus =
  | "IDLE"
  | "ORDER_CREATING"
  | "ORDER_CREATED"
  | "PAYMENT_OPEN"
  | "PAYMENT_SUCCESS"
  | "PAYMENT_FAILED"
  | "PAYMENT_CANCELLED";

export interface RazorpayOrder {
  id: string;
  amount: number;
  currency: string;
  [key: string]: any;
}

export interface RazorpaySuccessPayload {
  paymentId: string;
  orderId: string;
}

export interface RazorpayState {
  status: RazorpayStatus;
  loading: boolean;
  order: RazorpayOrder | null;
  success: RazorpaySuccessPayload | null;
  error: NormalizedError | null;
  lastArgs: StartPaymentArgs | null;
}

const initialState: RazorpayState = {
  status: "IDLE",
  loading: false,
  order: null,
  success: null,
  error: null,
  lastArgs: null,
};

const razorpaySlice = createSlice({
  name: "razorpaypg",
  initialState,
  reducers: {
    RazorpayStartRequested(state, action: PayloadAction<StartPaymentArgs>) {
      state.loading = true;
      state.error = null;
      state.status = "ORDER_CREATING";
      state.lastArgs = action.payload;
      state.order = null;
      state.success = null;
    },
    RazorpayOrderSucceeded(state, action: PayloadAction<RazorpayOrder>) {
      state.order = action.payload;
      state.status = "ORDER_CREATED";
      state.loading = false; // order create complete
    },
    RazorpayPaymentOpening(state) {
      state.status = "PAYMENT_OPEN";
    },
    RazorpayPaymentSucceeded(
      state,
      action: PayloadAction<RazorpaySuccessPayload>,
    ) {
      state.status = "PAYMENT_SUCCESS";
      state.success = action.payload;
      state.loading = false;
    },
    RazorpayPaymentFailed(state, action: PayloadAction<NormalizedError>) {
      state.status = "PAYMENT_FAILED";
      state.error = action.payload;
      state.loading = false;
    },
    RazorpayPaymentCancelled(state) {
      state.status = "PAYMENT_CANCELLED";
      state.loading = false;
    },
    RazorpayReset() {
      return initialState;
    },
  },
});

export const {
  RazorpayStartRequested,
  RazorpayOrderSucceeded,
  RazorpayPaymentOpening,
  RazorpayPaymentSucceeded,
  RazorpayPaymentFailed,
  RazorpayPaymentCancelled,
  RazorpayReset,
} = razorpaySlice.actions;

export default razorpaySlice.reducer;

// export type PgActions =
//   | typeof pgStartRequested
//   | typeof pgOrderSucceeded
//   | typeof pgPaymentOpening
//   | typeof pgPaymentSucceeded
//   | typeof pgPaymentFailed
//   | typeof pgPaymentCancelled
//   | typeof pgReset;
